import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap"
import { Form, Button, Card, InputGroup } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
import "./Login.css"
import loginImg from "../../assets/images/login.png"
import TRLogo from "../../assets/images/TR-logo.png"
import { useNavigate } from "react-router-dom";
import API from "../../services/axiosInstance";
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../security/authContext.js';
import { loggedInUserDetails } from '../utils/helper.js';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const { register, handleSubmit, formState: { errors }, } = useForm();

    // hooks
    const navigate = useNavigate();
    const { login } = useAuth();

    const loginUser = async (data) => {
        try {
            const response = await API.post("/auth/login", {
                userName: data.username,
                password: data.password
            });
            const token = response?.data?.data;
            if (token) {
                // decode token details
                const decoded = jwtDecode(token);
                localStorage.setItem("token", token);
                localStorage.setItem("username", decoded.sub);

                if (decoded.userId && decoded.accountType == 1) {
                    // set accounts details from api
                    const response = await API.get(`/publisher/accounts/userid/${decoded.userId}`);
                    
                    if (response.status === 200) {
                        const data = response.data.data;
                        // set some information into session 
                        localStorage.setItem("language", data.languageType);
                        localStorage.setItem("userId", data.id);
                        localStorage.setItem("userGuid", data.userGuid);
                    }
                }

                // context login details for set permission for context after login
                login(navigate);
            }
        } catch (err) {
            console.error(err);
        }
    };


    return (
        <section className="loginBg">
            <Container fluid>
                <Row className='loginPageAlign'>
                    <Col md={8} className="d-none d-md-block">
                        <img src={loginImg} alt="login" />
                    </Col>
                    <Col md={4} xs={12}>
                        <div className="loginForm">
                            <img src={TRLogo} alt="TR-logo" />
                            <Form onSubmit={handleSubmit(loginUser)}>
                                <Form.Group className="mb-3" controlId='userName'>
                                    <Form.Label>USER NAME</Form.Label>
                                    <InputGroup>
                                        <Form.Control type="text" placeholder="Enter user name" {...register("username", {
                                            required: "User name is required",
                                            validate: value =>
                                                value.trim() !== "" || "cannot be empty spaces"
                                        })} />
                                        <InputGroup.Text>
                                            <FaUser />
                                        </InputGroup.Text>
                                    </InputGroup>
                                    {errors.username && <small className='text-danger'>{errors.username.message}</small>}
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>PASSWORD</Form.Label>
                                    <InputGroup>
                                        <Form.Control type={showPassword ? 'text' : 'password'} placeholder="Enter password" {...register("password", { required: "Password is required" })} />
                                        <InputGroup.Text onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                                            {showPassword ?
                                                <FaEyeSlash /> :
                                                <FaEye />}
                                        </InputGroup.Text>
                                    </InputGroup>
                                    {errors.password && <small className='text-danger'>{errors.password.message}</small>}
                                </Form.Group>

                                <Button variant="primary" type="submit" className="w-100 mt-3">
                                    Login
                                </Button>
                            </Form>
                        </div>
                            <p style={{color:"#fff",fontSize:"14px",textAlign:"center", paddingTop:"12px", fontWeight:"300"}}>© 2026 <a href='https://www.momagic.com' target='_blank' className='anchorStyle'>MoMAGIC.com</a> | All Rights Reserved.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default Login;